import angular from 'angular';

import './redemptionDetails/redemptionDetails.module';

export default angular.module('app.communication.redemption', [
    'app.communication.redemption.redemptionDetails'
]);
